export default __webpack_public_path__ + "static/media/04.a5077332.svg";